import { ComponentType, ReactNode } from "react";
import { Layout as AntdLayout } from "antd";
import { toCssBox, usePagePadding } from "./pagePadding";

type AppShellLayoutProps = Readonly<{
  /** Left navigation (or an empty slot on chrome-less pages). */
  Sider: ComponentType;
  /** Top bar (mobile header spacer, or an empty slot). */
  Header: ComponentType;
  children: ReactNode;
}>;

// Minimum height of the content area, as in Refine's ThemedLayoutV2.
const CONTENT_MIN_HEIGHT = 360;

/**
 * App shell: sider + header + the content area with the shared page padding
 * (see `pagePadding.ts`). Replaces Refine's ThemedLayoutV2, whose content
 * padding is hardcoded (24px / 12px).
 */
export const AppShellLayout = ({
  Sider,
  Header,
  children,
}: AppShellLayoutProps) => {
  const padding = usePagePadding();

  return (
    <AntdLayout style={{ minHeight: "100vh" }} hasSider>
      <Sider />
      <AntdLayout>
        <Header />
        <AntdLayout.Content>
          <div
            style={{
              minHeight: CONTENT_MIN_HEIGHT,
              padding: toCssBox(padding),
            }}
          >
            {children}
          </div>
        </AntdLayout.Content>
      </AntdLayout>
    </AntdLayout>
  );
};
